import { render } from "./FormError.vue?vue&type=template&id=9efd53ea"
import script from "./FormError.vue?vue&type=script&lang=js"
export * from "./FormError.vue?vue&type=script&lang=js"
script.render = render

export default script